import { Alert } from '@cmsgov/ds-medicare-gov'
import { useTranslation } from 'react-i18next'

export const ChatBlockedAlert = () => {
  const { t } = useTranslation('accountHome', { keyPrefix: 'talkToSomeone' })

  return (
    <Alert variation="warn" className="ds-u-margin-top--3">
      {t('chatBlocked')}
    </Alert>
  )
}
